import AppDispatcher from "../Dispatcher";
import AppSDK from "@growthos/ui-app-sdk";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import TraffickingDataStore from "../Stores/TraffickingDataStore";
import { fetchWithAuthGet, fetchWithAuthPost } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";

const basePath = AppConfig.getBookApiBasePath();

export const fetchTraffickingRequestCampaigns = () => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Campaign/GetTraffickingRequestCampaigns/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}`
	)
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.getTraffickingCampaigns, // "GET_TRAFFICKING_CAMPAIGNS"
				value: response
			});
		})
		.catch((error) => {
			console.log("error", error);
		});
};

export const submitTraffickingRequest = (campaignID, placementIDs, hierarchyLevel, redirect) => {
	const hierarchyLevelCodes = { Placement: 1, AdSet: 2, LineItem: 3 };
	return fetchWithAuthPost(
		`${basePath.ApiBasePath}/plook/Placement/SubmitTraffickingRequestAllHierarchyLevels/${campaignID}/${hierarchyLevelCodes[hierarchyLevel]}`,
		JSON.stringify(placementIDs)
	)
		.then((response) => {
			AppDispatcher.dispatch({
				type: redirect ? AppActionConstants.submitTraffickingRequestRedirect : AppActionConstants.submitTraffickingRequestSuccess,
				value: response
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.submitTraffickingRequestFail,
				value: errorObject
			});
		});
};

export const startMappingProcess = (campaignID, advertiserID) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Advertiser/MapDCMHierarchies/${campaignID}/${advertiserID}`)
		.then((response) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.mappingSuccess,
				value: response
			});
			return response;
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.mappingFail,
				value: errorObject?.Errors || []
			});
			return errorObject?.Errors || [];
		});
};

export const getSiteContacts = (placementIDs) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Campaign/GetSiteInfoByPlacementIDs`, JSON.stringify(placementIDs));
};
